module.exports = __webpack_public_path__ + "static/pic01-d4a870cc3b20fac9a017a82a9a6711c8.jpg";